import { render, staticRenderFns } from "./AttractionDataFormComponent.vue?vue&type=template&id=bff0f07e&scoped=true&xmlns=true&"
import script from "./AttractionDataFormComponent.vue?vue&type=script&lang=js&"
export * from "./AttractionDataFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./AttractionDataFormComponent.vue?vue&type=style&index=0&id=bff0f07e&scoped=true&lang=css&"
import style1 from "./AttractionDataFormComponent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff0f07e",
  null
  
)

export default component.exports